import { getFlagValue, isFlagEnabled } from '@Redux/actions/flagsmith';
import { SUPPORTED_BANKS_THB } from '@Utils/constants';
import { ModalFactory } from '../../modal/modal';
import { UnSupportedBankAlertCard } from '../../un-supported-bank-popup-thb/UnSupportedBankAlertCard';
import { UNSUPPORTED_BANK_POP_UP_THB } from '../../alert-Message/constants';
import CommonButton from '../../common-button/CommonButton';

export const checkForTHBUnsupportedBank = ({ currencyCode, item, show, onResult }) => {
  if (currencyCode !== 'THB' || !item || item.trim().length < 2) return;

  const supportedBanks = isFlagEnabled(SUPPORTED_BANKS_THB)
    ? getFlagValue(SUPPORTED_BANKS_THB)
    : [];

  const isSupported = supportedBanks.some(
    (bank) => bank.trim().toLowerCase() === item.trim().toLowerCase()
  );
  if (show) {
    onResult(isSupported);
  }
};

export const showUnsupportedBankAlertModal = async () => {
  //@ts-ignore
  await ModalFactory.builder(
    (onClose) => <UnSupportedBankAlertCard onClose={onClose} />,
    'unsupported-bank-thb-alert-modal insta-modal center-modal',
    true
  );
};

export const renderTHBUnsupporteBankNote = () => {
  return (
    <span className="note">
      {UNSUPPORTED_BANK_POP_UP_THB.unsupportedThbBankMessage}
      <CommonButton
        text={UNSUPPORTED_BANK_POP_UP_THB.learnMore}
        type="link"
        onClick={showUnsupportedBankAlertModal}
      />
    </span>
  );
};
